import { render, staticRenderFns } from "./guide.vue?vue&type=template&id=4b113ba3&scoped=true&"
import script from "./guide.vue?vue&type=script&lang=ts&"
export * from "./guide.vue?vue&type=script&lang=ts&"
import style0 from "./guide.vue?vue&type=style&index=0&id=4b113ba3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b113ba3",
  null
  
)

export default component.exports